import { render, staticRenderFns } from "./duplicatecheckDetail.vue?vue&type=template&id=37e7ed39&scoped=true"
import script from "./duplicatecheckDetail.vue?vue&type=script&lang=js"
export * from "./duplicatecheckDetail.vue?vue&type=script&lang=js"
import style0 from "./duplicatecheckDetail.vue?vue&type=style&index=0&id=37e7ed39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7ed39",
  null
  
)

export default component.exports